export default "__VITE_ASSET__84YAxi3R__"